import '../../form.css'
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import constant from '../../../../constant';
const Index = ({ state, onChange, onSubmit, addRow, isFinalSubmitting, setIsFinalSubmitting, history }) => {

    return (
        <div className="row">
            <div className="col-md-12 ">
                <div className="appraisal-report-table-responsive">
                    <table
                        className="assessment-table inspn-assessment-table"
                        cellSpacing={0}
                    >
                        <tbody>
                            <tr className="bghed">
                                <td className="hd-s2 pd10">
                                                    {" "}
                                                    <p>S.No.</p>
                                                </td>
                                                <td className="hd-s2 pd10 w150">
                                                    <p>Date Issued</p>
                                                </td>
                                                <td className="hd-s2 pd10 w200">
                                                    <p>SQ reference number</p>
                                                </td>
                                                 <td className="hd-s2 pd10 w200">
                                                    <p>To and CC</p>
                                                </td>
                                                <td className="hd-s1 pd10">
                                                    <p>Subject</p>
                                                </td>
                                                <td className="hd-s2 pd10 w150">
                                                    <p>Status</p>
                                                </td>
                                                <td className="hd-s2 pd10 w150">
                                                    <p>Date Closed</p>
                                                </td>
                            </tr>
                            
                            {state.map((item, index) => {
                                return (
                                    <tr>
                                        <td className="td-s1">
                                            <p className="s1">{index + 1}.</p>
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="date"
                                                className="form-control"
                                                placeholder=""
                                                name={item.date_issued.name}
                                                value={item.date_issued.value}
                                                onChange={(e) => { onChange(item.date_issued.name, e.target.value, index) }}
                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                name={item.sq_reference_number.name}
                                                value={item.sq_reference_number.value}
                                                onChange={(e) => { onChange(item.sq_reference_number.name, e.target.value, index) }}

                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                name={item.to_and_cc.name}
                                                value={item.to_and_cc.value}
                                                onChange={(e) => { onChange(item.to_and_cc.name, e.target.value, index) }}

                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                name={item.subject.name}
                                                value={item.subject.value}
                                                onChange={(e) => { onChange(item.subject.name, e.target.value, index) }}

                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control narrow-date"
                                                placeholder=""
                                                name={item.status.name}
                                                value={item.status.value}
                                                onChange={(e) => { onChange(item.status.name, e.target.value, index) }}

                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="date"
                                                className="form-control"
                                                placeholder=""
                                                name={item.date_closed.name}
                                                value={item.date_closed.value}
                                                onChange={(e) => { onChange(item.date_closed.name, e.target.value, index) }}

                                            />
                                        </td>
                                        
                                    </tr>
                                )
                            })}


                            <tr className="addmoreitem">
                                <td className="td-s1" colSpan={15}>
                                    <button type="button" className="btn btn-link" onClick={() => { addRow() }}>
                                        + Add New Block
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="final-checkbox">
                        <div class="form-check">
                            <input class="form-check-input" name="discountCheckbox" type="checkbox" checked={isFinalSubmitting} onChange={() => { setIsFinalSubmitting() }} id="productdiscountCheck1" />
                            <label class="form-check-label" for="productdiscountCheck1">Send to Office for Review</label>
                        </div>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-lg-12 text-left ">
                        <button
                            type='button'
                            className="btn btn-success"
                            style={{
                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                borderColor: "#2b5a7e"
                            }}
                            onClick={() => { onSubmit() }}
                        >
                            Submit
                        </button>
                        <button
                            type="button"
                            className="btn btn-danger ms-3"
                            style={{
                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                borderColor: "#2b5a7e"
                            }}
                            onClick={() => { history.push(constant.Authedcomponent.siteManagement.url) }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouter(Index)